import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { paymentTypes } from "../../../../utils/constants";
import "./ViewBankDetailsModal.css";

const Field = ({ label, value, wide }) => (
  <div className={`vbdm__field${wide ? " vbdm__field--wide" : ""}`}>
    <div className="vbdm__field-label">{label}</div>
    <div className={`vbdm__field-value${!value ? " vbdm__field-value--empty" : ""}`}>
      {value || "—"}
    </div>
  </div>
);

const Section = ({ label, children, single }) => (
  <div className="vbdm__section">
    <div className="vbdm__section-label">{label}</div>
    <div className={`vbdm__grid${single ? " vbdm__grid--single" : ""}`}>
      {children}
    </div>
  </div>
);

const ViewBankDetailsModal = ({ isOpen, toggle, selectedBankDetail }) => {
  const type = selectedBankDetail?.type;

  const typeLabel = {
    [paymentTypes.IBAN]: "IBAN",
    [paymentTypes.SWIFT]: "SWIFT / BIC",
    [paymentTypes.REGNOACCOUNT]: "REGNO / ACCOUNT",
    [paymentTypes.ABARoutingNumber]: "ABA Routing Number",
  }[type] ?? type;

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="vbdm">
      {/* Custom header */}
      <div className="vbdm__header">
        <div className="vbdm__header-left">
          <div className="vbdm__title">Bank Account Details</div>
          {typeLabel && <span className="vbdm__type-badge">{typeLabel}</span>}
        </div>
        <button className="vbdm__close" onClick={toggle} aria-label="Close">×</button>
      </div>

      <ModalBody className="vbdm__body">

        {/* ── REGNO / ACCOUNT ── */}
        {type === paymentTypes.REGNOACCOUNT && (
          <>
            <Section label="Bank &amp; Location">
              <Field label="Bank" value={selectedBankDetail.bank} />
              <Field label="Address" value={selectedBankDetail.address} />
              <Field label="City" value={selectedBankDetail.city} />
              <Field label="Zip" value={selectedBankDetail.zip} />
              <Field label="Country" value={selectedBankDetail.country} />
            </Section>
            <div className="vbdm__divider" />
            <Section label="Account">
              <Field label="Registration No." value={selectedBankDetail.regNo} />
              <Field label="Account Number" value={selectedBankDetail.bankAccountNumber} />
              <Field label="IBAN" value={selectedBankDetail.iban} />
              <Field label="Currency" value={selectedBankDetail.currency?.currencyCode} />
            </Section>
          </>
        )}

        {/* ── IBAN ── */}
        {type === paymentTypes.IBAN && (
          <>
            <Section label="Bank &amp; Location">
              <Field label="Bank" value={selectedBankDetail.bank} />
              <Field label="Branch" value={selectedBankDetail.branch} />
              <Field label="Address" value={selectedBankDetail.address} />
              <Field label="City" value={selectedBankDetail.city} />
              <Field label="Zip" value={selectedBankDetail.zip} />
              <Field label="Country" value={selectedBankDetail.country} />
            </Section>
            <div className="vbdm__divider" />
            <Section label="Account">
              <Field label="Beneficiary Name" value={selectedBankDetail.beneficiaryBankAccountName} />
              <Field label="IBAN" value={selectedBankDetail.iban} />
              <Field label="Currency" value={selectedBankDetail.currency?.currencyCode} />
              <Field label="Country Code" value={selectedBankDetail.countryCode} />
            </Section>
          </>
        )}

        {/* ── SWIFT ── */}
        {type === paymentTypes.SWIFT && (
          <>
            <Section label="Bank &amp; Location">
              <Field label="Bank" value={selectedBankDetail.bank} />
              <Field label="Branch" value={selectedBankDetail.branch} />
              <Field label="Address" value={selectedBankDetail.address} />
              <Field label="City" value={selectedBankDetail.city} />
              <Field label="Zip" value={selectedBankDetail.zip} />
              <Field label="Country" value={selectedBankDetail.country} />
            </Section>
            <div className="vbdm__divider" />
            <Section label="Account">
              <Field label="Beneficiary Name" value={selectedBankDetail.beneficiaryBankAccountName} />
              <Field label="BIC / SWIFT" value={selectedBankDetail.bic} />
              <Field label="Account Number" value={selectedBankDetail.bankAccountNumber} />
              <Field label="Currency" value={selectedBankDetail.currency?.currencyCode} />
              <Field label="Country Code" value={selectedBankDetail.countryCode} />
            </Section>
          </>
        )}

        {/* ── ABA ROUTING NUMBER ── */}
        {type === paymentTypes.ABARoutingNumber && (
          <>
            <Section label="Bank &amp; Location">
              <Field label="Bank" value={selectedBankDetail.bank} />
              <Field label="Branch" value={selectedBankDetail.branch} />
              <Field label="Address" value={selectedBankDetail.address} />
              <Field label="City" value={selectedBankDetail.city} />
              <Field label="Zip" value={selectedBankDetail.zip} />
              <Field label="Country" value={selectedBankDetail.country} />
            </Section>
            <div className="vbdm__divider" />
            <Section label="Account">
              <Field label="ABA Routing Number" value={selectedBankDetail.abaRoutingNumber} />
              <Field label="Account Number" value={selectedBankDetail.bankAccountNumber} />
              <Field label="Beneficiary Name" value={selectedBankDetail.beneficiaryBankAccountName} />
              <Field label="Account Type" value={selectedBankDetail.accountType} />
              <Field label="Currency" value={selectedBankDetail.currency?.currencyCode} />
            </Section>
          </>
        )}

      </ModalBody>
    </Modal>
  );
};

export default ViewBankDetailsModal;

